import React from "react";
import AllRoutes from "./GeneralUse/AllRoutes";

function App() {
  return (
    <div>
      <AllRoutes />
    </div>
  );
}

export default App;
